import styles from './index.module.less';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';
import { useConfigProvider } from '@/context/ConfigProvider';
const Index = ({ platListItem, sixPlatList }: { platListItem: any; sixPlatList: any }) => {
  const router = useRouter();
  const { isMobile } = useConfigProvider();
  const { t } = useTranslation();
  return (
    <div
      className={styles.container}
      id="Comparison with Other Platforms"
      style={{ scrollMarginTop: isMobile ? '100px' : '200px' }}
    >
      <h2>
        {t('Compare')} {capitalizeFirstLetter(platListItem.platform)} {t('and other websites')}
      </h2>
      <p style={{ fontSize: '16px' }}>
        {t(
          'telegroupslink.com is not the only competitor in the social media network industry. Learn how onlyfans-info.ru compares to other major competitors',
        )}
      </p>
      <ul className={styles.list}>
        {sixPlatList.map((item: any, index: number) => (
          <li
            key={item.platform}
            style={{ flexDirection: index % 2 === 0 ? 'row' : 'row-reverse' }}
            onClick={() => {
              router.push(`/compare/${item.platform}-vs-${platListItem.platform}`);
            }}
          >
            <div>
              <Image src={item.icon} alt={item.platform} height={30} width={30} loading="lazy" />
              <div>{capitalizeFirstLetter(item.platform)}</div>
            </div>
            <div></div>
            <div>
              <Image src={platListItem.icon} alt={platListItem.platform} height={30} width={30} loading="lazy" />

              <div>{capitalizeFirstLetter(platListItem.platform)}</div>
            </div>
            <div className={styles.vs}>vs</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;
